import * as React from "react";

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {}

export const Card: React.FC<CardProps> = ({ style, children, ...rest }) => (
  <div
    style={{
      background: "var(--surface-card, var(--white))",
      border: "1px solid var(--n100)",
      borderRadius: 14,
      padding: 24,
      boxShadow: "var(--shadow-card)",
      ...style,
    }}
    {...rest}
  >
    {children}
  </div>
);
